import { Injectable, inject } from '@angular/core';
import type { ButtonColor } from '@cf/core';
import type { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@tolgee/ngx';
import { ConfirmationModalComponent } from '../modals/confirmation/confirmation.modal';

export interface OpenConfirmationParams {
  heading: string;
  text: string;
  buttonName: string;
  cancelButtonName: string;
  checkBoxTitle?: string;
  buttonColor?: ButtonColor;
}

@Injectable({
  providedIn: 'root',
})
export class ModalService {
  translateService = inject(TranslateService);
  modal = inject(NgbModal);

  openConfirmation({
    heading,
    text,
    buttonName,
    cancelButtonName = '',
    checkBoxTitle = '',
    buttonColor = 'primary',
  }: OpenConfirmationParams): NgbModalRef {
    const modal = this.modal.open(ConfirmationModalComponent, { size: 'medium' });
    const modalInstance = modal.componentInstance as ConfirmationModalComponent;

    modalInstance.heading = heading;
    modalInstance.text = text;
    modalInstance.confirmationButton = buttonName;
    modalInstance.buttonColor = buttonColor;
    modalInstance.cancelButtonName =
      cancelButtonName || this.translateService.instant('dialog.buttons.cancel');
    modalInstance.checkBoxTitle = checkBoxTitle;
    return modal;
  }
}
